<a class="special-card rise-on-hover" [href]="special.button.link">
  <h1>{{special.title}}</h1>
  <h2>{{special.text}}</h2>
  <button class="d-block d-md-block">{{special.button.text}}</button>
  <img alt="Soccer field" [src]="backgroundImage" loading="lazy">
</a>
